import React from "react";

/**
 * Animierter (indeterminierter) Fortschrittsbalken für Lade-/Ausführungsvorgänge,
 * deren tatsächliche Dauer nicht bekannt ist.
 *
 * Props:
 *  - label: optionaler Text oberhalb des Balkens (z.B. "Suche nach Duplikaten…")
 */
export default function ProgressBar({ label }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, padding: "10px 0" }}>
      {label && <div style={{ fontSize: 13, color: "#666" }}>{label}</div>}
      <div className="progress-bar" />
    </div>
  );
}
